import { useFormik } from 'formik'
import { useEffect, useState } from 'react'
import * as Yup from 'yup'
import ImageUpload from '../../components/ImageUpload'
import Select from 'react-select'
import {
	appAllGetCompliance,
	appCreateCompliance,
	appDeleteCompliance,
	appUpdateCompliance,
	uploadComplianceImage,
} from '../../store/compliances'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import swal from 'sweetalert'
import { appGetSansthaById } from '../../store/sanstha'
import { appAllGetComplianceDate } from '../../store/compliancesDate'

import {
	complianceDocumentExportColumns,
	complianceDueDateExportColumns,
} from '../../config/exportColumns/complianceExportColumns'
import ExportButton from '../../common/ExportButton'

function TableFilter() {
	const dispatch = useDispatch()
	const navigate = useNavigate()

	const [activeTab, setActiveTab] = useState('document')
	const [editMode, setEditMode] = useState(false)
	const [editId, setEditId] = useState(null)
	const [showModal, setShowModal] = useState(false)

	const sansthaId = localStorage.getItem('sansthaId')
	const permissionOfSanstha = localStorage.getItem('permissionOfSanstha')

	const sansthaDetails = useSelector(state => state.sansthaReducer.sansthaDetails)

	const compliancesList = useSelector(state => state.complianceReducer.compliancesList)

	const compliancesDate = useSelector(state => state.complianceDateReducer.compliancesDate)

	const complianceOptions =
		Array.isArray(compliancesDate) &&
		compliancesDate.map(item => ({
			value: item._id,
			label: item.name,
		}))

	useEffect(() => {
		dispatch(appGetSansthaById(sansthaId || permissionOfSanstha))
		dispatch(appAllGetComplianceDate())
		dispatch(appAllGetCompliance({ sanstha: sansthaId || permissionOfSanstha }))
	}, [dispatch, sansthaId, permissionOfSanstha])

	const formik = useFormik({
		initialValues: {
			compliancedate: '',
			file: '',
			filingDate: '',
			frequency: '',
		},
		validationSchema: Yup.object({
			compliancedate: Yup.string().required('Compliance type is required'),
			frequency:
				activeTab === 'document' ? Yup.string().required('Frequency is required') : Yup.string(),
			filingDate:
				activeTab === 'dueDate' ? Yup.string().required('Filing date is required') : Yup.string(),
		}),
		onSubmit: values => {
			const payload = {
				compliancedate: values.compliancedate,
				file: values.file,
				filingDate: values.filingDate,
				frequency: values.frequency,
				sanstha: sansthaDetails?._id,
				complianceduedate: activeTab === 'dueDate',
				navigate,
			}

			const filtered_obj = Object.fromEntries(
				Object.entries(payload).filter(
					([k, v]) => v !== '' && v !== null && v !== undefined && k !== 'navigate',
				),
			)

			if (editMode && editId) {
				dispatch(appUpdateCompliance({ ...filtered_obj, id: editId })).then(() => resetForm())
			} else {
				dispatch(appCreateCompliance(filtered_obj)).then(() => resetForm())
			}
		},
	})

	const resetForm = () => {
		setShowModal(false)
		setEditMode(false)
		setEditId(null)
		formik.resetForm()
		dispatch(appAllGetCompliance({ sanstha: sansthaDetails?._id }))
	}

	const handleEdit = compliance => {
		setEditMode(true)
		setEditId(compliance._id)
		setShowModal(true)

		formik.setValues({
			compliancedate: compliance.compliancedate?._id || '',
			file: compliance.file || '',
			filingDate: compliance.filingDate || '',
			frequency: compliance.frequency || '',
		})
	}

	const handleDelete = id => {
		swal({
			title: 'Are you sure?',
			text: 'You want to delete this Compliance?',
			icon: 'warning',
			buttons: true,
			dangerMode: true,
		}).then(ok => {
			if (ok) {
				dispatch(appDeleteCompliance(id)).then(() => {
					dispatch(appAllGetCompliance({ sanstha: sansthaDetails?._id }))
				})
			}
		})
	}

	const filteredCompliances = compliancesList?.filter(c =>
		activeTab === 'document' ? !c.complianceduedate : c.complianceduedate,
	)

	return (
		<div>
			<ul className="nav nav-tabs mb-3">
				<li className="nav-item">
					<button
						className={`nav-link ${activeTab === 'document' ? 'active' : ''}`}
						onClick={() => setActiveTab('document')}
					>
						Compliance Document
					</button>
				</li>
				<li className="nav-item">
					<button
						className={`nav-link ${activeTab === 'dueDate' ? 'active' : ''}`}
						onClick={() => setActiveTab('dueDate')}
					>
						Compliance Due Date
					</button>
				</li>
			</ul>

			<div className="mb-3 d-flex justify-content-between align-items-center">
				<h4>
					Total Compliance:{' '}
					{
						compliancesList?.filter(c =>
							activeTab === 'document' ? !c.complianceduedate : c.complianceduedate,
						).length
					}
				</h4>

				<div className="d-flex gap-2">
					<ExportButton
						fetchAction={params =>
							dispatch(
								appAllGetCompliance({
									...params,
									sanstha: sansthaDetails?._id,
									complianceduedate: activeTab === 'dueDate',
									page: 1,
									limit: 10000,
									loading: false,
								}),
							).then(res => {
								const data =
									res?.payload?.responses?.data?.data ||
									res?.payload?.data?.data ||
									res?.payload?.data ||
									res?.payload ||
									[]

								return {
									payload: {
										data: data.filter(item =>
											activeTab === 'document' ? !item.complianceduedate : item.complianceduedate,
										),
									},
								}
							})
						}
						columns={
							activeTab === 'document'
								? complianceDocumentExportColumns
								: complianceDueDateExportColumns
						}
						fileName={activeTab === 'document' ? 'Compliance_Documents' : 'Compliance_Due_Dates'}
						sheetName={activeTab === 'document' ? 'Compliance Documents' : 'Compliance Due Dates'}
						buttonText={
							activeTab === 'document'
								? 'Export Compliance Documents'
								: 'Export Compliance Due Dates'
						}
					/>

					<button
						className="btn btn-primary"
						style={{ marginLeft: '10px' }}
						onClick={() => {
							setShowModal(true)
							setEditMode(false)
							setEditId(null)
							formik.resetForm()
						}}
					>
						+ Add New
					</button>
				</div>
			</div>

			{/* TABLE */}
			<div className="table-responsive">
				<table className="table table-bordered table-hover">
					<thead>
						<tr>
							<th>Sr. No.</th>
							<th>Document Name</th>

							{activeTab === 'document' ? (
								<th>Periodic Type</th>
							) : (
								<>
									<th>Compliance Date</th>
									<th>Filing Date</th>
								</>
							)}

							{activeTab === 'document' && <th>File</th>}
							{activeTab === 'document' && <th>Date of Upload</th>}
							<th>Actions</th>
						</tr>
					</thead>

					<tbody>
						{compliancesList &&
						compliancesList.filter(c =>
							activeTab === 'document' ? !c.complianceduedate : c.complianceduedate,
						).length > 0 ? (
							compliancesList
								.filter(c =>
									activeTab === 'document' ? !c.complianceduedate : c.complianceduedate,
								)
								.map((c, i) => (
									<tr key={i}>
										<td>{i + 1}</td>
										<td>{c.compliancedate?.name || 'N/A'}</td>

										{activeTab === 'document' ? (
											<>
												<td>{c.frequency}</td>

												<td>
													{c.file ? (
														c.file.includes('.pdf') ? (
															<a
																href={c.file}
																target="_blank"
																className="btn btn-sm btn-outline-primary"
															>
																PDF
															</a>
														) : (
															<img
																src={c.file}
																width={60}
																height={60}
																style={{ objectFit: 'contain' }}
															/>
														)
													) : (
														'N/A'
													)}
												</td>

												<td>{new Date(c.createdAt).toLocaleDateString('en-US')}</td>
											</>
										) : (
											<>
												<td>{c?.compliancedate?.documentDuedate || '-'}</td>

												<td>
													{c.filingDate ? new Date(c.filingDate).toLocaleDateString('en-US') : '-'}
												</td>
											</>
										)}

										<td>
											<button className="btn btn-sm btn-primary mr-2" onClick={() => handleEdit(c)}>
												Edit
											</button>
											<button className="btn btn-sm btn-danger" onClick={() => handleDelete(c._id)}>
												Delete
											</button>
										</td>
									</tr>
								))
						) : (
							<tr>
								<td colSpan="6" className="text-center">
									No compliance found
								</td>
							</tr>
						)}
					</tbody>
				</table>
			</div>

			{/* MODAL */}
			{showModal && (
				<div
					className="modal fade show"
					style={{
						display: 'block',
						backgroundColor: 'rgba(0,0,0,0.5)',
						marginTop: '35px',
					}}
				>
					<div className="modal-dialog">
						<div className="modal-content">
							<div className="modal-header">
								<h5>{editMode ? 'Edit Compliance' : 'Add Compliance'}</h5>
								<button className="close" onClick={resetForm}>
									×
								</button>
							</div>

							<div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
								<form onSubmit={formik.handleSubmit}>
									{/* Compliance Type Dropdown */}
									<div className="form-group mb-3">
										<label>Compliance Type *</label>
										<Select
											name="compliancedate"
											options={complianceOptions}
											value={
												complianceOptions?.find(
													opt => opt.value === formik.values.compliancedate,
												) || null
											}
											onChange={option => {
												formik.setFieldValue('compliancedate', option.value)

												const selected = compliancesDate.find(c => c._id === option.value)

												if (selected?.documentLifetime) {
													formik.setFieldValue('frequency', selected.documentLifetime)
												}
											}}
										/>
										{formik.touched.compliancedate && formik.errors.compliancedate && (
											<div className="text-danger">{formik.errors.compliancedate}</div>
										)}
									</div>

									{/* File Upload */}
									{activeTab === 'document' && (
										<div className="form-group mb-3">
											<ImageUpload
												label="File"
												uploadFunction={uploadComplianceImage}
												fieldName="file"
												value={formik.values.file}
												onChange={value => formik.setFieldValue('file', value.url)}
											/>
										</div>
									)}

									{/* Frequency or Filing Date */}
									{activeTab === 'document' ? (
										<div className="form-group mb-3">
											<label>Frequency *</label>
											<select
												className="form-control"
												name="frequency"
												value={formik.values.frequency}
												onChange={formik.handleChange}
											>
												<option value="">Select option</option>
												<option value="Recurring">Recurring</option>
												<option value="One Time">One Time</option>
												<option value="Yearly">Yearly</option>
												<option value="Half-yearly">Half-yearly</option>
												<option value="Quarterly">Quarterly</option>
												<option value="Monthly">Monthly</option>
												<option value="Lifetime">Lifetime</option>
											</select>

											{formik.touched.frequency && formik.errors.frequency && (
												<div className="text-danger">{formik.errors.frequency}</div>
											)}
										</div>
									) : (
										<div className="form-group mb-3">
											<label>Filing Date *</label>
											<input
												type="date"
												className="form-control"
												name="filingDate"
												value={formik.values.filingDate}
												onChange={formik.handleChange}
											/>
											{formik.touched.filingDate && formik.errors.filingDate && (
												<div className="text-danger">{formik.errors.filingDate}</div>
											)}
										</div>
									)}
								</form>
							</div>

							<div className="modal-footer">
								<button className="btn btn-secondary" onClick={resetForm}>
									Cancel
								</button>

								<button className="btn btn-primary" onClick={formik.handleSubmit}>
									Save
								</button>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	)
}

export default TableFilter
